<ng-container *ngTemplateOutlet="templateRef"></ng-container>
